const month = [{
    id: '01',
    text: 'January',
},
{
    id: '02',
    text: 'February',
},
{
    id: '03',
    text: 'March',
},
{
    id: '04',
    text: 'April',
},
{
    id: '05',
    text: 'May',
},
{
    id: '06',
    text: 'June',
},
{
    id: '07',
    text: 'July',
},
{
    id: '08',
    text: 'August',
},
{
    id: '09',
    text: 'September',
},
{
    id: '10',
    text: 'October',
},
{
    id: '11',
    text: 'November',
},
{
    id: '12',
    text: 'December',
},
]

const CURRENT_YEAR = new Date().getUTCFullYear()
const PREV_YEAR = CURRENT_YEAR - 1

function changeKey(year) {
    return (item) => ({
        ...item,
        id: `${year}-${item.id}`,
    })
}

function sortMonth(monthAttr) {
    const currentMonth = new Date().getMonth()
    const defaultMinth = {
        id: 'all',
        text: 'Alle',
    }
    const prevMonth = monthAttr.slice(0, currentMonth + 1).map(changeKey(CURRENT_YEAR)).reverse()
    const nextMonth = monthAttr.slice(currentMonth + 1, monthAttr.length).map(changeKey(PREV_YEAR)).reverse()

    return [defaultMinth, ...prevMonth, ...nextMonth]
}

export default sortMonth(month)
